<template>
  <div>
    <slot name="list"></slot>
    <div ref="tag"></div>

    <div class="list-donetip" v-show="!isLoading && isDone">
      <slot name="doneTip">没有更多数据了</slot>
    </div>

    <div class="list-loading" v-show="isLoading">
      <slot name="loadingTip">加载中</slot>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {getScrollview} from '../assets/utils';

  window.$inquiry = window.$inquiry || new Vue();

  export default {
    name: 'infinitescroll',
    data() {
      return {
        isLoading: false,
        isDone: false
      };
    },
    props: {
      onInfinite: {
        type: Function,
        required: true
      }
    },
    methods: {
      init() {
        this.scrollview = getScrollview(this.$el);

        this.scrollview.addEventListener('scroll', () => {
          this.throttle(this.scrollHandler);
        });

        window.$inquiry.$on('infinitescroll.loadedDone', () => {
          this.isLoading = false;
          this.isDone = true;
        });

        window.$inquiry.$on('infinitescroll.finishLoad', () => {
          this.isLoading = false;
        });
      },
      scrollHandler() {
        const scrollview = this.scrollview;
        const contentHeight = scrollview === window ? document.body.offsetHeight : scrollview.offsetHeight;
        const offsetTop = scrollview === window ? 0 : scrollview.getBoundingClientRect().top;
        if (this.isLoading || this.isDone) {
          console.log('e');
          // return false;
        } else if (this.$refs.tag.getBoundingClientRect().top <= (offsetTop + contentHeight + (contentHeight / 10))) {
          this.isLoading = true;
          this.onInfinite();
        }
      },
      throttle(method, context) {
        clearTimeout(method.tId);
        method.tId = setTimeout(() => {
          method.call(context);
        }, 100);
      }
    },
    mounted() {
      this.$nextTick(this.init);
    },
    destroyed() {
      this.scrollview.removeEventListener('scroll', this.scrollHandler);
    }
  };
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// InfiniteScroll.vue?2e35f41a